import { useAuth } from "@/context/AuthContext";

// PATCH 36 Me9 — a genuinely personalised greeting: the user's own name, plus their sector/region
// where known — a small, real "this was set up for me" signal. Never invents details it doesn't have.
function partOfDay() {
  const h = new Date().getHours();
  return h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
}

export default function Greeting({ sector, region, testid = "dashboard-greeting" }) {
  const { user } = useAuth();
  const first = (user?.name || "").trim().split(/\s+/)[0];
  const bits = [sector, region].filter(Boolean);
  return (
    <p className="k-muted" data-testid={testid} style={{ margin: "2px 0 0", fontSize: 13 }}>
      {partOfDay()}{first ? `, ${first}` : ""}.
      {bits.length ? ` Your workspace is set up for ${bits.join(" · ")}.` : ""}
    </p>
  );
}
